module.exports = __webpack_public_path__ + "static/media/unknown.fe37fb05.svg";